import http from '@/http'

export default {
  namespaced: true,
  actions: {
    async getArrayBuffer(context, uuid) {
      const response = await http.get(`upload/${uuid}`, { responseType: 'arraybuffer' })

      return response
    },
  },
}
